import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusGreenSpaces = (props) => {
    const width = props.width ? props.width + 'px' : '59px';
    const height = props.height ? props.height + 'px' : '38px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 59 38"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.1346 24.1775V31.3755H30.7498V24.1775C36.6997 23.314 41.2803 18.2478 41.2803 12.1562C41.2803 5.45074 35.748 0 28.949 0C22.15 0 16.6108 5.45074 16.6108 12.1562C16.6108 18.2546 21.1914 23.314 27.1414 24.1775H27.1346ZM28.9422 3.56187C33.7487 3.56187 37.6583 7.41381 37.6583 12.1495C37.6583 16.8851 33.7487 20.7371 28.9422 20.7371C24.1356 20.7371 20.226 16.8851 20.226 12.1495C20.226 7.41381 24.1356 3.56187 28.9422 3.56187ZM7.28183 18.241C10.6695 18.2392 13.4201 15.5078 13.4201 12.1561C13.4201 8.8034 10.6676 6.07129 7.2784 6.07129C3.88917 6.07129 1.14355 8.79666 1.14355 12.1561C1.14355 15.5145 3.89417 18.2392 7.28183 18.241ZM7.2784 9.03951C9.01753 9.03951 10.428 10.4359 10.428 12.1561C10.428 13.8764 9.01753 15.2728 7.2784 15.2728C5.53928 15.2728 4.13566 13.8764 4.13566 12.1561C4.13566 10.4359 5.54613 9.03951 7.2784 9.03951ZM58.6987 34.1211H0V38H58.6987V34.1211ZM6.01824 31.3753H3.01929V22.727H0.129883V19.7588H14.4331V22.727H11.5369V31.3753H8.54476V22.727H6.01824V31.3753ZM48.6749 31.3754V27.321H48.6612C44.8337 26.498 41.9512 23.1386 41.9512 19.118C41.9512 14.4835 45.7718 10.7192 50.4756 10.7192C55.1794 10.7192 59 14.4902 59 19.118C59 23.1386 56.1243 26.498 52.29 27.321V31.3754H48.6749ZM55.3848 19.118C55.3848 16.4533 53.187 14.2879 50.4824 14.2879C47.7779 14.2879 45.58 16.4533 45.58 19.118C45.58 21.7826 47.7779 23.9481 50.4824 23.9481C53.187 23.9481 55.3848 21.7826 55.3848 19.118Z"
            />
        </SvgStyled>
    );
};

export default CampusGreenSpaces;
